import { useTranslation } from 'react-i18next';

import { Redirect, Route, Switch } from '@treams/treams-routes';
import { Container, Jumbo, Tabs } from '@treams/treams-ui';

import LearningTypes from 'packages/kakapo-ui-settings-application/pages/learning/components/LearningTypes';
import LearningSubjects from 'packages/kakapo-ui-settings-application/pages/learning/components/LearningSubjects';
import LearningCertificates from 'packages/kakapo-ui-settings-application/pages/learning/components/LearningCertificates';
import {
	default as LearningCertificateCreator,
	LearningCertificateEditWithID,
} from 'packages/kakapo-ui-settings-application/pages/learning/components/LearningCertificateEdit';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';

export default function LearningSettings() {
	const { t } = useTranslation();
	const enabledLearningCertificates = useFeature('2024.learning.certificates');

	return (
		<>
			<Jumbo
				title={t('settings.learning.title')}
				description={t('settings.learning.description')}
				footer={
					<Tabs.Container mb="-1px" wide={1080}>
						<Tabs.Item title={t('settings.learning.types.title')} path="/settings/learning/types" />
						<Tabs.Item
							title={t('settings.learning.subjects.title')}
							path="/settings/learning/subjects"
						/>
						{enabledLearningCertificates && (
							<Tabs.Item
								title={t('settings.learning.certificates.title')}
								path={['/settings/learning/certificates', '/settings/learning/certificates/:id']}
							/>
						)}
					</Tabs.Container>
				}
				wide={1080}
			/>
			<Container py={3} wide={1080}>
				<Switch>
					<Route path="/settings/learning/types">
						<LearningTypes />
					</Route>
					<Route path="/settings/learning/subjects">
						<LearningSubjects />
					</Route>
					<Route path="/settings/learning/certificates/new">
						<LearningCertificateCreator />
					</Route>
					<Route<{ id: string }> path="/settings/learning/certificates/:id">
						{({ match }) => <LearningCertificateEditWithID id={match!.params.id!} />}
					</Route>
					<Route path="/settings/learning/certificates">
						<LearningCertificates />
					</Route>
					<Route>
						<Redirect to="/settings/learning/types" />
					</Route>
				</Switch>
			</Container>
		</>
	);
}
